import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/components/layout/index.vue";
import SimpleLayout from "@/components/layout/index-simple.vue";
import UserCenterLayout from "@/components/layout/user-center.vue";
import Home from '@/views/home/index.vue'
import store from '@/store'
import {i18n} from '@/util/i18n';

Vue.use(VueRouter)

const routes = [
    {
        path: '/stripe-test-success',
        component: () => import('@/views/payment/stripe-test-return.vue'),
        meta: { title: 'Stripe' }
    },
    {
        path: '/stripe-test-cancel',
        component: () => import('@/views/payment/stripe-test-return.vue'),
        meta: { title: 'Stripe' }
    },
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '',
                component: Home,
                name: 'home',
                meta: { title: 'home.title', headerAutoHidden: true, keepAlive: true }
            }
        ]
    },
    // {
    //     path: '/regions',
    //     component: Layout,
    //     children: [
    //         {
    //             path: '',
    //             component: () => import(/* webpackChunkName: "locations" */ '@/views/regions/index.vue'),
    //             name: 'regions',
    //             meta: { title: 'Provide Proxies coverage 99% areas of the World' }
    //         },
    //         {
    //             path: ':regionCode.html',
    //             component: () => import(/* webpackChunkName: "locations" */ '@/views/regions/region.vue'),
    //             name: 'region',
    //             meta: { title: 'Provide Proxies coverage 99% areas of the World' }
    //         }
    //     ]
    // },
    {
        path: '/help',
        component: Layout,
        children: [
            {
                path: '/privacy',
                component: () => import(/* webpackChunkName: "privacy" */ '@/views/help/privacy.vue'),
                name: 'privacy',
                meta: { title: 'privacy.title', headerAutoHidden: true }
            },
            {
                path: '/terms',
                component: () => import(/* webpackChunkName: "terms" */ '@/views/help/terms.vue'),
                name: 'terms',
                meta: { title: 'terms.title', headerAutoHidden: true }
            }
        ]
    },
    {
        path: '/faq',
        component: Layout,
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "faq-index" */ '@/views/faq/index.vue'),
                name: 'faq-index',
                meta: { title: 'faq.title' }
            },
            {
                path: ':subtitle.html',
                component: () => import(/* webpackChunkName: "faq" */ '@/views/faq/faq.vue'),
                name: 'faq',
                meta: { title: 'faq_article.title' }
            }
        ]
    },
    {
        path: '/cases',
        component: Layout,
        children: [
            {
                path: ':name',
                component: () => import(/* webpackChunkName: "seo" */ '@/views/cases/index.vue'),
                name: 'seo',
                meta: { title: 'cpts.scenes.title'  }
            },
        ]
    },
    {
        path: '/pricing',
        component: Layout,
        children: [
            {
                path: '/staticisp',
                component: () => import(/* webpackChunkName: "staticISP" */ '@/views/pricing/static.vue'),
                name: 'static',
                meta: { title: 'pricing.static_ips.title', keepAlive: true }
            },
            {
                path: '/staticisp/:regionCode.html',
                component: () => import(/* webpackChunkName: "staticISP" */ '@/views/pricing/static.vue'),
                name: 'static-region',
                meta: { title: 'pricing.static_ips.title', keepAlive: true }
            },
            {
                path: '/residential',
                component: () => import(/* webpackChunkName: "residential" */ '@/views/pricing/residential.vue'),
                name: 'residential',
                meta: { title: 'pricing.residential.title', keepAlive: true }
            },
        ]
    },
    {
        path: '/signup',
        component: SimpleLayout,
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "signup" */ '@/views/page/signUp.vue'),
                name: 'signup',
                meta: { title: 'signup.title' }
            }
        ]
    },
    {
        path: '/login',
        component: SimpleLayout,
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "login" */ '@/views/page/login.vue'),
                name: 'login',
                meta: { title: 'login.title' }
            }
        ]
    },
    {
        path: '/findpassword',
        component: SimpleLayout,
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "req_reset_pwd" */ '@/views/page/findpassword.vue'),
                name: 'findpassword',
                meta: { title: 'find_password.title' }
            },
            {
                path: '/resetpassword',
                alias: '/reset-password',
                component: () => import(/* webpackChunkName: "resetpwd" */ '@/views/page/resetpassword.vue'),
                name: 'resetpassword',
                meta: { title: 'resetpassword.title' }
            }
        ]
    },
    {
        path: '/payment',
        component: SimpleLayout,
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "payment" */ '@/views/payment/index.vue'),
                name: 'payment',
                meta: { title: 'cpts.payment_view.title', requiresAuth: true }
            }
        ]
    },
    {
        path: '/ucenter',
        component: UserCenterLayout,
        children: [
            {
                path: 'info',
                component: () => import(/* webpackChunkName: "info" */ '@/views/ucenter/index.vue'),
                name: 'info',
                meta: { title: 'dashboard.title', requiresAuth: true }
            },
            {
                path: 'use_proxy',
                component: () => import(/* webpackChunkName: "use_proxy" */ '@/views/ucenter/use_proxy/index.vue'),
                name: 'use_proxy',
                meta: { title: 'use_proxy.title', requiresAuth: true }
            },
            {
                path: 'sdk',
                component: () => import(/* webpackChunkName: "sdk" */ '@/views/ucenter/use_proxy/sdk.vue'),
                name: 'sdk',
                meta: { title: 'sdk.title', requiresAuth: true }
            },
            {
                path: 'staticisp',
                component: () => import(/* webpackChunkName: "ustaticISP" */ '@/views/ucenter/staticisp/index.vue'),
                name: 'ucenter-static',
                meta: { title: 'buy_isp_proxy.title', requiresAuth: true }
            },
            {
                path: 'staticisp/ips',
                component: () => import(/* webpackChunkName: "uc_ipm" */ '@/views/ucenter/staticisp/ip-mgr.vue'),
                name: 'ucenter-staticisp-history-ips',
                meta: { title: 'ipmgr.title', requiresAuth: true }
            },
            {
                path: 'staticisp/orders',
                component: () => import(/* webpackChunkName: "uc_staic_order" */ '@/views/ucenter/staticisp/staticisp-orders.vue'),
                name: 'ucenter-staticisp-history-orders',
                meta: { title: 'staticisp_orders.title', requiresAuth: true }
            },
            {
                path: 'residential',
                component: () => import(/* webpackChunkName: "uc_residential" */ '@/views/ucenter/residential/index.vue'),
                name: 'ucenter-residential-buy',
                meta: { title: 'residential.title', requiresAuth: true }
            },
            {
                path: 'residential/orders',
                component: () => import(/* webpackChunkName: "uc_residential_order" */ '@/views/ucenter/residential/residential-orders.vue'),
                name: 'ucenter-residential-history-orders',
                meta: { title: 'residential_orders.title', requiresAuth: true }
            },
            {
                path: 'wallet',
                component: () => import(/* webpackChunkName: "ustaticISP" */ '@/views/ucenter/wallet/wallet-setting.vue'),
                name: 'ucenter-wallet',
                meta: { title: 'wallet_settings.title', requiresAuth: true }
            },
            {
                path: 'wallet/deposit',
                component: () => import(/* webpackChunkName: "ustaticISP" */ '@/views/ucenter/wallet/wallet-deposit.vue'),
                name: 'ucenter-wallet-orders',
                meta: { title: 'wallet_deposit.title', requiresAuth: true }
            },
            {
                path: 'wallet/usage',
                component: () => import(/* webpackChunkName: "ustaticISP" */ '@/views/ucenter/wallet/wallet-usage.vue'),
                name: 'ucenter-wallet-usage',
                meta: { title: 'wallet_usage.title', requiresAuth: true }
            },
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
})
// 全局拦截
router.beforeEach((to, from, next) => {
    // console.log(`route from ${from.path} to ${to.path}`)
    // const app = router.app;
    // if (app && app.$refs && app.$refs.loading) {
    //   app.$refs.loading.show();
    // }

    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    if (nearestWithTitle) {
        document.title = i18n.t(nearestWithTitle.meta.title) || 'SparkProxy';
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (from.path !=='/login'){
            // console.log(store.state.isLogin)
            if (store.state.isLogin){
                next(); //不拦截，放行
            } else {
                next({path: '/login', query: {redirect: encodeURIComponent(to.fullPath)}})
            }
        } else {
            next()
        }
    } else {
        next()
    }
})
  
// router.afterEach(() => {
//     const app = router.app;
//     if (app && app.$refs && app.$refs.loading) {
//       setTimeout(() => {
//         app.$refs.loading.hide();
//       }, 1000);
//     }
// });

export default router
